import {
  DomainAPI,
  Channel,
  APIKey,
  Authorization,
  SecretApiKey,
  SecretApiKeyExpires,
} from "../utils/setting";

import jwt from "jsonwebtoken";
import { checkResponse } from "../utils/checkResponse";

const stableCost = {
  state: {
    stableCost: JSON.stringify([]),
  },
  reducers: {
    setState(state, payload) {
      this.state = { ...state, ...payload };
      return { ...this.state };
    },
  },
  effects: (dispatch) => ({
    async getStableCost(payload, rootState) {
      let url =
        DomainAPI + Channel + "/api/secure/serviceStableCost/getStableCost";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "post",
        headers: myHeaders,
      })
        .then((res) => res.json())
        .then((result) => {
          // _this.setState({stableCost: result.data.length ?  JSON.stringify(result.data[0].serviceCost):  JSON.stringify([])})
          // if (result.code === 1) _this.setState({ fanpageId: result.data.fanpageId })
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async updateStableCost(payload, rootState) {
      let url =
        DomainAPI + Channel + "/api/secure/serviceStableCost/updateStableCost";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "post",
        headers: myHeaders,
        body: JSON.stringify({ serviceCost: payload.serviceCost }),
      })
        .then((res) => res.json())
        .then((result) => {
          // if (result.code === 1) _this.setState({ fanpageId: result.data.fanpageId })
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
  }),
};

export default stableCost;
